// extracted by mini-css-extract-plugin
export default {"temperatureRange":"CoolingCircuts_temperatureRange__ZCiPU"};